module.exports = __webpack_public_path__ + "assets/img/1_928_big.d03cc6a8.jpg";